import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { TeamContextProvider } from './hooks/useTeamContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Layout } from './components/layout/Layout';
import { LoginPage } from './components/auth/LoginPage';
import { Dashboard } from './components/dashboard/Dashboard';
import { SiteDetails } from './components/sites/SiteDetails';
import { ScanResults } from './components/results/ScanResults';
import { IssueDetailPage } from './components/results/IssueDetailPage';
import { TrashView } from './components/trash/TrashView';
import { AdminPage } from './components/admin/AdminPage';
import { GscCallback } from './components/gsc/GscCallback';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <TeamContextProvider>
                <Layout />
              </TeamContextProvider>
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="sites/:siteId" element={<SiteDetails />} />
          <Route path="sites/:siteId/scans/:scanId" element={<ScanResults />} />
          <Route path="sites/:siteId/scans/:scanId/issues/:issueId" element={<IssueDetailPage />} />
          <Route path="sites/:siteId/schedules" element={<SiteDetails />} />
          <Route path="trash" element={<TrashView />} />
          <Route path="admin" element={<AdminPage />} />
          <Route path="gsc-callback" element={<GscCallback />} />
        </Route>

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
